<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-center">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Token</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br /><br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="bg-purple-card" style="padding: 15px; height: 55px; align-items: center;">
            <div class="text-center">
                <label class="custom-font-setting2"> 1 Token is equals to RM1 </label>
            </div>
          </div>

          <br />

          <label class="custom-14px" style="color: #212529; font-weight: 600;"> Select Credit </label>

          <br />

          <div>
            <CRow class="justify-content-center mb-2">
              <CCol sm="12" lg="12"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
                left: 0;
                right: 0;
                bottom: 0px;
                "
              >
                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;">
                    <label class="custom-12px mb-0" > RM 30 </label>
                  </CCard>
                </CCol>

                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;">
                    <label class="custom-12px mb-0" > RM 60 </label>
                  </CCard>
                </CCol>

                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;">
                    <label class="custom-12px mb-0" > RM 90 </label>
                  </CCard>
                </CCol>
              </CCol>
            </CRow>
          </div>

          <div>
            <CRow class="justify-content-center mb-2">
              <CCol sm="12" lg="12"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
                left: 0;
                right: 0;
                bottom: 0px;
                "
              >
                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;">
                    <label class="custom-12px mb-0" > RM 120 </label>
                  </CCard>
                </CCol>

                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;">
                    <label class="custom-12px mb-0" > RM 150 </label>
                  </CCard>
                </CCol>

                <CCol sm="4" lg="3" class="p-0 mr-2" style="width: 33%">
                  <CCard class="text-center" style="
                    border-radius: 12px;
                    background: #FFF;
                    border: none;
                    padding: 15px;" @click="customAmount">
                    <label class="custom-12px mb-0" > Custom </label>
                  </CCard>
                </CCol>
              </CCol>
            </CRow>
          </div>

          <div v-if="amountCustom == true" class="">
          <!-- <div class="popup-all1"> -->
            <!-- Popup content -->
            <div class="text-left">
              <!-- <img style="max-width:100%" src="../assets/img/success.png" /> -->
              <label class="custom-14px" style="color: #323C66; font-weight: 600;"> How much token do you want? </label>
              <input type="text" class="border-white-50px custom-font-setting" style="border-radius: 9px;" placeholder="min. 30" />
            </div>
          <!-- </div> -->
        </div>

          <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

          <CButton type="button" class="button-border-blue text-white mt-4 mb-5" block>Continue</CButton>
          <br /><br />

        </div>
      
        
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
              amountCustom: false,

  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        // GoToWhatsapp() {
        //   this.$router.push("/EditProfile");
        // },

        customAmount() {
          this.amountCustom = true;
        },

        // closePopup() {
        //   this.$router.push("/EditSocmed");
        // }
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>